@if (session(); as currentSession) {
  @if (currentSession.loggedIn) {
    <app-dropdown #menuDropdown="appDropdown">
      <button
        dropdownTrigger
        type="button"
        class="profile-trigger"
        (click)="menuDropdown.toggle()"
        [attr.aria-expanded]="menuDropdown.open()"
        [attr.aria-label]="'nav.profileMenu' | translate">
        @if (currentSession.avatarUrl && !avatarFailed()) {
          <img
            class="profile-avatar"
            [src]="currentSession.avatarUrl"
            alt=""
            width="40"
            height="40"
            (error)="onAvatarError()" />
        } @else {
          <app-icon name="circle-user" [size]="22" />
        }
      </button>
      <div dropdownPanel class="profile-panel" [class.profile-panel--open]="menuDropdown.open()">
        <span class="profile-username">{{ currentSession.username }}</span>
        <a class="profile-row" [routerLink]="'profile' | localizedLink">
          <app-icon name="user-round" [size]="18" />
          <span>{{ 'nav.myProfile' | translate }}</span>
        </a>
        @if (currentSession.isAdmin || currentSession.adminSessionExpired) {
          <a class="profile-row" [routerLink]="'adminOverview' | localizedLink">
            <app-icon name="shield-check" [size]="18" />
            <span>{{ 'nav.backoffice' | translate }}</span>
          </a>
        }
        <button type="button" class="profile-row profile-row--logout" (click)="logout()">
          <app-icon name="log-out" [size]="18" />
          <span>{{ 'nav.adminLogout' | translate }}</span>
        </button>
      </div>
    </app-dropdown>
  } @else {
    <a
      class="profile-trigger"
      href="/auth/player/login"
      (click)="trackLogin()"
      [attr.aria-label]="'nav.signIn' | translate"
      [title]="'nav.signIn' | translate">
      <app-icon name="circle-user" [size]="20" />
    </a>
  }
}
